module.exports = __webpack_public_path__ + "static/media/tresd-icon.78d13413.svg";